import Vue from 'vue'
import axios from '@axios'

export default {
  namespaced: true,
  state: {
    subsystemTree: [],
    subsystemTreeCopy: [],
    subsystemHasNoData: false,
    subsystemTreeAlarmBridge: [],
    isSearch: false,
    focusedFacility: null,
    maintenanceByUnit: {}
  },
  mutations: {
    removeFromAlarmBridgeTree(state,value) {
      state.subsystemTreeAlarmBridge = state.subsystemTreeAlarmBridge.filter(item => item.id !== value.id)
    },
    addToAlarmBridgeTree(state,value) {
      const payload = {
        id: value.id,
        data: value.children
      }
      state.subsystemTreeAlarmBridge.push(payload)
    },
    updateNodeByID(state, value) {
      state.subsystemTree.forEach(tenant => {
        if(tenant.id === value.tenantId) {
            // tenant -> facilities
            tenant.children.forEach((child) => {
              // Facility
              if (child.id === value.facility.id) {
                // Facility status icon
                // child.icon = value.facility.icon;
                updateItemById(tenant.children, value.device.id, value.device)
              }
            })
        }
      });
    },
    clearSubsystemTree(state) {
      state.subsystemTree = []
    },
    setCurrentTreeCopy(state) {
      state.subsystemTree = state.subsystemTreeCopy
    },
    saveCurrentTree(state) {
      state.subsystemTreeCopy = state.subsystemTree
    },
    clearFacilitiesOfTenant(state, id) {
      state.subsystemTree.forEach(tenant => {
        if(tenant.id === id) {
          tenant.children = []
        }
      });
    },
    setFacilitiesToTenant(state, value){
      state.subsystemTree.forEach(tenant => {
        if (!value.data.length) { tenant.loading = false; return}
        if(tenant.id === value.data[0].id_tenant) {
          tenant.children = [];
          const showOpen = state.isSearch && value.data.length <= 3;
          value.data.forEach(facilitie => {
            const [facilityNode] = createSubsystemTree(facilitie.subsystem_tree, showOpen);
            if (facilityNode) facilityNode.in_project = resolveInProject(state, facilitie, facilityNode);
            tenant.children.push(facilityNode)
          });
          tenant.currentPageFacilities = value.meta?.current_page
          tenant.lastPageFacilities = value.meta?.last_page
          tenant.opened = true;
          tenant.loading = false;
        }
      });
    },
    setFacilitiesToNode(state, value) {
      const node = findItemById(state.subsystemTree, value.nodeId);
      if (!node) return;

      node.children = value.data.map(facility => {
        const [facilityNode] = createSubsystemTree(facility.subsystem_tree);
        if (facilityNode) facilityNode.in_project = resolveInProject(state, facility, facilityNode);
        return facilityNode;
      });
      node.currentPageFacilities = value.meta?.current_page;
      node.lastPageFacilities = value.meta?.last_page;
      node.opened = true;
      node.loading = false;
    },
    setFacilityMaintenanceStatus(state, { facilityId, tenantId, inProject }) {
      const flag = toMaintenanceFlag(inProject);
      Vue.set(state.maintenanceByUnit, String(facilityId), flag);
      applyMaintenanceToTrees(state, facilityId, flag, tenantId);
      const unit = state.units?.find(record => sameId(record.id, facilityId));
      if (unit) Vue.set(unit, 'in_project', flag);
    },
    // First-load source of truth: the in_project each unit carries in its own GET.
    setMaintenanceFromUnits(state, units) {
      if (!Array.isArray(units)) return;
      units.forEach(record => {
        if (!record || record.id == null || record.in_project === undefined) return;
        const flag = toMaintenanceFlag(record.in_project);
        Vue.set(state.maintenanceByUnit, String(record.id), flag);
        applyMaintenanceToTrees(state, record.id, flag);
      });
    },
    setFocusedFacility(state, facility) {
      setTreeSelection(state.subsystemTree, facility);
      state.focusedFacility = facility
        ? {
            id: facility.unit_data?.id ?? facility.unit_data?.id_unit ?? facility.id,
            unit_data: facility.unit_data || null,
            text: facility.text || facility.name || facility.description || ''
          }
        : null;
    }
  },
  getters: {
    getSubsystemTree(state) {
      return state.subsystemTree
    },
    getDataSatus(state) {
      return state.subsystemHasNoData;
    },
    getAlarmBridgeTree(state) {
      return state.subsystemTreeAlarmBridge
    },
    getFocusedFacility(state) {
      return state.focusedFacility
    },
    getDefaultItemOfTree() {
      const item = initializeDataItem({})
      return item
    }
  },
  actions: {
    getTenantsByUser({ commit, state, dispatch }) {
      state.subsystemHasNoData = false;
      if(state.subsystemTree.length > 0) return
      axios.get('/v1/services/subsystem-tree/tenants-by-user').then(({ data }) => {
        state.subsystemTree = createSubsystemTree(data.data);
      }).catch((error) => {
        state.subsystemHasNoData = true;
      });
    },
    getFacilitiesByNode({ commit, state }, { nodeId, url }) {
      state.subsystemHasNoData = false;
      axios.get(url).then(({ data }) => {
        commit('setFacilitiesToNode', {
          nodeId,
          data: data.data,
          meta: data.meta,
        });
      }).catch(() => {
        const node = findItemById(state.subsystemTree, nodeId);
        if (node) node.loading = false;
        state.subsystemHasNoData = true;
      });
    },

    getFacilitiesBySearch({ commit, state }, search) {
      state.subsystemHasNoData = false;
      const url = `/v1/services/subsystem-tree/search?q=${search}&max=20`;
      commit("clearSubsystemTree");
      axios.get(url).then(({ data }) => {
        if(data.data.length === 0) { state.subsystemHasNoData = true; return}
        const childrens = [];
        state.isSearch = true;
        data.data.forEach(tenant => { childrens.push(tenant.children) });
        const tenantData = createTenantTreeBySearch([...data.data])
        state.subsystemTree = tenantData;
        childrens.forEach(tenant => {
          commit('setFacilitiesToTenant',tenant)
        });
      }).catch((error) => {
        state.subsystemHasNoData = true;
      });
    },
    setNodeData({ commit, state }, data) {
      commit('updateNodeByID',data.data)
    },
    setFacilityMaintenanceStatus({ commit }, payload) {
      commit('setFacilityMaintenanceStatus', payload)
    },
    setMaintenanceFromUnits({ commit }, units) {
      commit('setMaintenanceFromUnits', units)
    }
  },
}

function resolveInProject(state, facility, facilityNode) {
  if (typeof facility.in_project === "boolean") return facility.in_project;
  const cached = state.maintenanceByUnit?.[String(facility.id)];
  if (typeof cached === "boolean") return cached;
  const unit = state.units.find(record => sameId(record.id, facility.id));
  if (unit && unit.in_project !== undefined) return toMaintenanceFlag(unit.in_project);
  return toMaintenanceFlag(facilityNode.in_project);
}

function toMaintenanceFlag(value) {
  if (typeof value === "string") return value === "1" || value.toLowerCase() === "true";
  return !!value;
}

function applyMaintenanceToTrees(state, facilityId, inProject, tenantId = null) {
  [state.subsystemTree, state.subsystemTreeCopy].forEach(tree => {
    if (!Array.isArray(tree)) return;
    tree.forEach(tenant => {
      if (tenantId != null && !sameId(tenant.id, tenantId)) return;
      (tenant.children || []).forEach(facilityNode => {
        if (facilityNode && isFacilityNodeOfUnit(facilityNode, facilityId)) {
          Vue.set(facilityNode, 'in_project', inProject);
        }
      });
    });
  });
}

function sameId(a, b) {
  return a != null && b != null && String(a) === String(b);
}

function setTreeSelection(nodes, selectedFacility) {
  if (!Array.isArray(nodes)) return;
  nodes.forEach(node => {
    const isSelected = !!selectedFacility && node === selectedFacility;
    if (node.selected !== isSelected) Vue.set(node, 'selected', isSelected);
    setTreeSelection(node.children, selectedFacility);
  });
}

function isFacilityNodeOfUnit(node, facilityId) {
  if (sameId(node.id, facilityId)) return true;
  return node.unit_data
    ? sameId(node.unit_data.id, facilityId) || sameId(node.unit_data.id_unit, facilityId)
    : false;
}

function createTenantTreeBySearch(data) {
  data.forEach(tenant => {
    tenant.children = []
   });

  const result = createSubsystemTree(data)
  return result;
}

function resolveDeviceIcon(currentIcon, nextIcon) {
  if (typeof currentIcon !== 'string' || typeof nextIcon !== 'string') return nextIcon;
  if (!currentIcon.includes('custom-camera-ptz-')) return nextIcon;
  return nextIcon.replace(/custom-camera-(online|offline)/, 'custom-camera-ptz-$1');
}

function refreshBodyWornDockIcon(dock) {
  if (dock.tag !== 'body-worn-dock' || !Array.isArray(dock.children)) return;

  const anyCameraOnline = dock.children.some(
    (child) => typeof child.icon === 'string' && /custom-camera-(ptz-)?online/.test(child.icon)
  );

  dock.icon = `feather icon-hard-drive ${anyCameraOnline ? 'text-success' : 'text-danger'}`;
}

function updateItemById(arr, id, actionData) {
  for (let item of arr) {
    // Parents
    if (item.id === id || item.data?.camera_proxy_id === id) {
      item.icon = resolveDeviceIcon(item.icon, actionData.icon);
      return true;
    }

    if (Array.isArray(item.data)) {
      item.data.forEach(element => {
        if (element.id === id) { }
        // element.subsystem_tree_data.actions.forEach(actions => {
        //   actions.children.forEach(action => {
        //     if(action.id === actionData.id) {
        //       action.status = actionData.status;
        //       action.icon = actionData.icon
        //     }
        //   });
        // });
      });
    }
    if (item.children && updateItemById(item.children, id, actionData)) {
      refreshBodyWornDockIcon(item);
      return true;
    }
  }
  return false;
}

function findItemById(items, id) {
  // Only lazy-load nodes carry facilitiesUrl; tenants share the numeric id space with unit nodes.
  for (const item of items) {
    if (item.facilitiesUrl && item.id === id) return item;

    if (Array.isArray(item.children)) {
      const child = findItemById(item.children, id);
      if (child) return child;
    }
  }

  return null;
}

function createSubsystemTree(items, showOpen=false) {
  items.forEach(treeItem => {
    treeItem = initializeDataItem(treeItem, showOpen);
    if (Array.isArray(treeItem.children)) {
      createSubsystemTree(treeItem.children);
    }
  });
  return items;
}

function initializeDataItem(item, showOpen=false) {
  if(!item) return;
  item.opened = showOpen && item.tag === "facility"
  item.selected = false;
  item.disabled = false;
  item.loading = false;
  if (["master_tenant", "tenant", "center", "sector"].includes(item.tag)) {
    item.icon = "feather icon-box";
  }

  let node = item;
  if (item.tag === "url") node['text'] = item.unit_data.description;
  let self = this;
  node.addBefore = function (data, selectedNode) {
    let newItem = initializeDataItem(data);
    let index = selectedNode.parentItem.findIndex((t) => t.id === node.id);
    selectedNode.parentItem.splice(index, 0, newItem);
  };
  node.addAfter = function (data, selectedNode) {
    let newItem = initializeDataItem(data);
    let index = selectedNode.parentItem.findIndex((t) => t.id === node.id) + 1;
    selectedNode.parentItem.splice(index, 0, newItem);
  };
  node.addChild = function (data) {
    let newItem = initializeDataItem(data);
    // node.opened = true;
    node["children"].push(newItem);
  };
  node.openChildren = function () {
    node.opened = true;
    self.handleRecursionNodeChildren(node, (node) => {
      node.opened = true;
    });
  };
  node.closeChildren = function () {
    node.opened = false;
    self.handleRecursionNodeChildren(node, (node) => {
      node.opened = false;
    });
  };
  return node;
}
